module.exports = __webpack_public_path__ + "img/src/components/ContactForm/avatar.png?e446a3b8";